import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase';

function TicketForm() {
  const [form, setForm] = useState({
    title: '',
    description: '',
    userEmail: '',
    appVersion: '', // Für die spezifische Versionsnummer
    appType: 'iOS', // Für den App-Typ (iOS oder Android)
    priority: 'mittel'
  });
  const [screenshot, setScreenshot] = useState(null);
  const [screenshotPreview, setScreenshotPreview] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleScreenshotChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      setScreenshot(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setScreenshotPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeScreenshot = () => {
    setScreenshot(null);
    setScreenshotPreview('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      let screenshotURL = '';
      
      // Upload screenshot if exists
      if (screenshot) {
        const storageRef = ref(storage, `screenshots/${Date.now()}_${screenshot.name}`);
        await uploadBytes(storageRef, screenshot);
        screenshotURL = await getDownloadURL(storageRef);
      }
      
      // Kombinierte App-Version erstellen
      const combinedAppVersion = form.appVersion 
        ? `${form.appType} ${form.appVersion}` 
        : form.appType;
      
      // Add document to Firestore
      await addDoc(collection(db, 'tickets'), {
        ...form,
        appVersion: combinedAppVersion, // Kombinierte Version verwenden
        screenshotURL,
        to: ['info@farukiyyeapp.de'], // Empfänger-E-Mail-Adresse
        message: {
          subject: `Neues Feedback-Ticket: ${form.title}`,
          text: `Neues Ticket: ${form.title}\nBeschreibung: ${form.description}\nPriorität: ${form.priority}\nE-Mail: ${form.userEmail}\nApp-Version: ${combinedAppVersion}`,
          html: `<div style="font-family:Arial,sans-serif">
            <h1>Neues Feedback-Ticket</h1>
            <h2>${form.title}</h2>
            <div style="background:#f5f7fd;padding:10px;border-radius:5px">
              <p>${form.description}</p>
            </div>
            <table>
              <tr><td><b>Status:</b></td><td>Neu</td></tr>
              <tr><td><b>Priorität:</b></td><td>${form.priority}</td></tr>
              <tr><td><b>E-Mail:</b></td><td>${form.userEmail}</td></tr>
              <tr><td><b>App-Version:</b></td><td>${combinedAppVersion}</td></tr>
            </table>
            ${screenshotURL ? `<p><b>Screenshot:</b> <a href="${screenshotURL}">Anzeigen</a></p>` : ''}
            <p><a href="https://farukiyyeappticket.web.app">Zum Dashboard →</a></p>
            <p>Diese E-Mail wurde automatisch gesendet.</p>
          </div>`
        },
        status: 'new',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      
      setSubmitted(true);
      setForm({
        title: '',
        description: '',
        userEmail: '',
        appVersion: '',
        appType: 'iOS',
        priority: 'mittel'
      });
      setScreenshot(null);
      setScreenshotPreview('');
    } catch (err) {
      setError('Ticket gönderilirken hata oluştu. Lütfen daha sonra tekrar deneyin.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setSubmitted(false);
    setError('');
  };

  return (
    <div style={{ 
      fontFamily: 'Inter, system-ui, sans-serif',
      backgroundColor: '#f5f7fd',
      minHeight: '100vh',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '600px', 
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
        padding: '30px',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            borderRadius: '8px', 
            backgroundColor: '#f0eafb',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '12px'
          }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#5b21b6' }}>F</span>
          </div>
          <h1 style={{ margin: 0, fontSize: '24px', color: '#1e293b' }}>Geribildirim gönder</h1>
        </div>
        
        {submitted ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f0fdf4', 
              color: '#166534',
              borderRadius: '8px',
              marginBottom: '25px',
              border: '1px solid #dcfce7'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>✅</div>
              <h2 style={{ margin: '0 0 10px 0', color: '#166534' }}>Geri bildiriminiz için teşekkür ederiz!</h2>
              <p style={{ marginBottom: '20px' }}>Bu sorunla/talebinizle mümkün olan en kısa sürede ilgileneceğiz. Ancak, çeşitli testler ve güncellemeler nedeniyle bunun biraz zaman alabileceğini lütfen unutmayın.</p>
              <button
                onClick={resetForm}
                style={{ 
                  background: '#5b21b6', 
                  color: 'white',
                  padding: '12px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}
              >
                Neues Feedback senden
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ 
                padding: '12px 15px', 
                backgroundColor: '#fef2f2', 
                color: '#b91c1c',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #fee2e2'
              }}>
                <p style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '8px' }}>⚠️</span>
                  {error}
                </p>
              </div>
            )}
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500',
                color: '#374151' 
              }}>
                Başlık:
              </label>
              <input
                type="text"
                name="title"
                value={form.title}
                onChange={handleChange}
                placeholder="Sorunun kısa bir açıklamasını yapın"
                style={{ 
                  width: '100%', 
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  boxSizing: 'border-box',
                  ':focus': {
                    borderColor: '#5b21b6'
                  }
                }}
                required
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500',
                color: '#374151' 
              }}>
                Açıklama:
              </label>
              <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                placeholder="Olabildiğince ayrıntılı olarak geri bildiriminizi veya sorununuzu açıklayın"
                style={{ 
                  width: '100%', 
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  fontSize: '16px',
                  minHeight: '120px',
                  resize: 'vertical',
                  outline: 'none',
                  fontFamily: 'inherit',
                  transition: 'border-color 0.2s',
                  boxSizing: 'border-box',
                  ':focus': {
                    borderColor: '#5b21b6'
                  }
                }}
                required
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500',
                color: '#374151' 
              }}>
                Ekran görüntüsü ekle (isteğe bağlı):
              </label>
              
              {!screenshotPreview ? (
                <div style={{
                  border: '2px dashed #e2e8f0',
                  borderRadius: '8px',
                  padding: '20px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: '#f8fafc'
                }}
                onClick={() => document.getElementById('screenshot-upload').click()}
                >
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                    <p style={{ margin: '10px 0 0', color: '#64748b' }}>Ekran görüntüsü yüklemek için tıklayın</p>
                    <p style={{ margin: '5px 0 0', fontSize: '12px', color: '#94a3b8' }}>
                      PNG, JPG veya JPEG (max. 5MB)
                    </p>
                  </div>
                  <input
                    id="screenshot-upload"
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleScreenshotChange}
                    style={{ display: 'none' }}
                  />
                </div>
              ) : (
                <div style={{
                  position: 'relative',
                  marginTop: '10px'
                }}>
                  <img 
                    src={screenshotPreview} 
                    alt="Screenshot Preview" 
                    style={{
                      width: '100%',
                      maxHeight: '200px',
                      objectFit: 'contain',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0'
                    }}
                  />
                  <button
                    type="button"
                    onClick={removeScreenshot}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: 'rgba(0,0,0,0.5)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"/>
                      <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                </div>
              )}
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500',
                color: '#374151' 
              }}>
                E-Mail:
              </label>
              <input
                type="email"
                name="userEmail"
                value={form.userEmail}
                onChange={handleChange}
                placeholder="senin@email.de"
                style={{ 
                  width: '100%', 
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  boxSizing: 'border-box',
                  ':focus': {
                    borderColor: '#5b21b6'
                  }
                }}
                required
              />
            </div>
            
            {/* Aktualisierter App-Version-Bereich */}
            <div style={{ 
              display: 'flex', 
              flexDirection: 'row',
              gap: '20px',
              marginBottom: '25px',
              flexWrap: 'wrap'
            }}>
              <div style={{ flex: '1', minWidth: '200px' }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '500',
                  color: '#374151' 
                }}>
                  mobil işletim sistemi:
                </label>
                <select
                  name="appType"
                  value={form.appType}
                  onChange={handleChange}
                  style={{ 
                    width: '100%', 
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: '16px',
                    outline: 'none',
                    backgroundColor: 'white',
                    appearance: 'none',
                    backgroundImage: 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 15px top 50%',
                    backgroundSize: '12px auto',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="iOS">iOS</option>
                  <option value="Android">Android</option>
                </select>
              </div>
              
              <div style={{ flex: '1', minWidth: '200px' }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '500',
                  color: '#374151' 
                }}>
                  Versiyon (optional):
                </label>
                <input
                  type="text"
                  name="appVersion"
                  value={form.appVersion}
                  onChange={handleChange}
                  placeholder={form.appType === 'iOS' ? "z.B. 16.5.1" : "z.B. 13.0"}
                  style={{ 
                    width: '100%', 
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: '16px',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>
            
            <div style={{ 
              display: 'flex', 
              flexDirection: 'row',
              gap: '20px',
              marginBottom: '25px',
              flexWrap: 'wrap'
            }}>
              <div style={{ flex: '1', minWidth: '200px' }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '500',
                  color: '#374151' 
                }}>
                  Öncelikli:
                </label>
                <select
                  name="priority"
                  value={form.priority}
                  onChange={handleChange}
                  style={{ 
                    width: '100%', 
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: '16px',
                    outline: 'none',
                    backgroundColor: 'white',
                    appearance: 'none',
                    backgroundImage: 'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 15px top 50%',
                    backgroundSize: '12px auto',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="niedrig">Düşük</option>
                  <option value="mittel">Orta</option>
                  <option value="hoch">Yüksek</option>
                </select>
              </div>
            </div>
            
            <button
              type="submit"
              disabled={isSubmitting}
              style={{ 
                width: '100%',
                background: 'linear-gradient(135deg, #4a00e0, #8e2de2)', 
                color: 'white',
                padding: '14px 15px',
                border: 'none',
                borderRadius: '8px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                fontSize: '16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                opacity: isSubmitting ? 0.7 : 1
              }}
            >
              {isSubmitting ? (
                <>
                  <span style={{ 
                    display: 'inline-block',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '3px solid rgba(255,255,255,0.3)',
                    borderTopColor: 'white',
                    animation: 'spin 1s linear infinite',
                    marginRight: '10px'
                  }}></span>
                  Gönderiliyor...
                </>
              ) : (
                'Geri bildirim gönderin'
              )}
            </button>
              <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              
              @media (max-width: 600px) {
                input, textarea, select, button {
                  font-size: 14px !important;
                }
              }
            `}</style>
          </form>
        )}
      </div>
    </div>
  );
}

export default TicketForm;